module.exports = __webpack_public_path__ + "media/images/lp/img_voice_02-f0e4f7cf19565251a1876a35966e4582.png";